var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeV3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.90234C6.48 1.90234 2 6.16381 2 11.4145C2 16.6653 6.48 20.9267 12 20.9267C17.52 20.9267 22 16.6653 22 11.4145C22 6.16381 17.52 1.90234 12 1.90234ZM4 11.4145C4 10.8343 4.08 10.2636 4.21 9.72137L8.99 14.2682V15.2194C8.99 16.2658 9.89 17.1219 10.99 17.1219V18.9577C7.06 18.4821 4 15.286 4 11.4145ZM17.89 16.5511C17.63 15.7806 16.89 15.2194 15.99 15.2194H14.99V12.3658C14.99 11.8426 14.54 11.4145 13.99 11.4145H7.99V9.5121H9.99C10.54 9.5121 10.99 9.08405 10.99 8.56088V6.65844H12.99C14.09 6.65844 14.99 5.80234 14.99 4.756V4.366C17.92 5.48844 20 8.22795 20 11.4145C20 13.3931 19.19 15.2004 17.89 16.5511Z",
    fill: "#171D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeV3);
export default __webpack_public_path__ + "static/media/globeV3.65e81afefc667cef9b544362c3527019.svg";
export { ForwardRef as ReactComponent };